const STORAGE_PREFIX = 'bg-popup-hide-'
const HIDE_MS = 24 * 60 * 60 * 1000

function storageKey (idx) {
  return STORAGE_PREFIX + String(idx)
}

export function isPopupHidden (idx) {
  if (idx == null || idx === '') return true
  const raw = window.localStorage.getItem(storageKey(idx))
  if (!raw) return false
  const expires = Number(raw)
  if (!Number.isFinite(expires) || Date.now() >= expires) {
    window.localStorage.removeItem(storageKey(idx))
    return false
  }
  return true
}

export function hidePopupFor24Hours (idx) {
  if (idx == null || idx === '') return
  window.localStorage.setItem(storageKey(idx), String(Date.now() + HIDE_MS))
}

export function filterVisiblePopups (list) {
  if (!Array.isArray(list)) return []
  return list.filter(item => item && item.idx != null && !isPopupHidden(item.idx))
}

export function toPopupContentHtml (text) {
  if (!text) return ''
  const value = String(text)
  if (/<[a-z][\s\S]*>/i.test(value)) return value
  return value.replace(/\n/g, '<br>')
}

function stripStyleDimensionRules (style) {
  return String(style || '')
    .replace(/(?:^|;)\s*(?:width|height|max-width|max-height|min-width|min-height)\s*:[^;]+;?/gi, '')
    .replace(/^\s*;|;\s*$/g, '')
    .trim()
}

export function sanitizeNoticeImages (html) {
  if (!html) return ''
  return String(html).replace(/<img\b([^>]*)>/gi, (match, attrs) => {
    let cleaned = String(attrs)
      .replace(/\s(?:width|height)\s*=\s*(?:"[^"]*"|'[^']*'|\S+)/gi, '')

    cleaned = cleaned.replace(/\sstyle\s*=\s*"([^"]*)"/gi, (full, style) => {
      const next = stripStyleDimensionRules(style)
      return next ? ` style="${next}"` : ''
    })
    cleaned = cleaned.replace(/\sstyle\s*=\s*'([^']*)'/gi, (full, style) => {
      const next = stripStyleDimensionRules(style)
      return next ? ` style='${next}'` : ''
    })

    return `<img${cleaned}>`
  })
}

export function prepareNoticeContentHtml (text) {
  return sanitizeNoticeImages(toPopupContentHtml(text))
}

export function isImagePopupContent (text) {
  const html = prepareNoticeContentHtml(text)
  if (!/<img\b/i.test(html)) return false
  const textOnly = html.replace(/<[^>]+>/g, '').replace(/\s+/g, '')
  return textOnly.length < 24
}
